import brand from '@helpers/brand';
import { fonts } from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import { ButtonStyles } from '@stories/Components/Buttons/Button/Button.styles';
import styled from 'styled-components';
const Container = styled.section `
  --tagHeight: 32px;

  position: relative;
  border-top: 2px solid ${brand.primary.alt};
  padding: 15px;
  margin-top: var(--tagHeight);
  background-color: ${brand.white};
  display: flex;
  flex-direction: column;

  &[data-has-tag='false'] {
    --tagHeight: 0;
  }
`;
const Tag = styled.div `
  ${fonts.DaxPro.Regular};
  background-color: ${brand.primary.alt};
  color: ${brand.white};
  height: var(--tagHeight);
  position: absolute;
  bottom: 100%;
  left: 0;
  padding: 6px 15px;
  font-size: 16px;
  line-height: 18px;

  @media ${until(Device.TabletLarge)} {
    bottom: calc(100% + 5px);
    font-size: 14px;
    line-height: 16px;
    --tagHeight: 28px;
  }
`;
const Inner = styled.div `
  height: 100%;
  display: flex;
  flex-direction: column;
`;
const TopRow = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 10px;
`;
const DateBox = styled.div `
  background-color: ${brand.grey.grey96};
  font-size: 14px;
  line-height: 16px;
  padding: 4px 7px;

  span {
    ${fonts.DaxPro.Medium};
    display: inline-block;
    padding-right: 2px;
  }
`;
const Date = styled.time ``;
const IconBox = styled.div ``;
const Icon = styled.span `
  display: block;
  height: 40px;
`;
const ContentRow = styled.div `
  margin-bottom: 24px;
`;
const Title = styled.h4 `
  ${fonts.DaxPro.Medium};
  font-size: 18px;
  margin-bottom: 5px;
`;
const Description = styled.p `
  ${fonts.DaxPro.Regular};
  font-size: 16px;
  line-height: 26px;
`;
const BaseRow = styled.div `
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;

  ${ButtonStyles.Button} {
    margin-left: auto;
  }
`;
const Downloads = styled.span `
  ${fonts.DaxPro.Medium};
  color: ${brand.primary.alt};
  font-size: 16px;
  line-height: 26px;

  @media ${until(Device.TabletLarge)} {
    font-size: 14px;
  }
`;
const ItemType = styled.div `
  &[data-item-type='YS'] svg {
    height: 24px;
  }

  &[data-item-type='YSP'] svg {
    height: 30px;
  }
`;
const DownloadCardStyles = {
    BaseRow,
    Container,
    ContentRow,
    Date,
    DateBox,
    Description,
    Downloads,
    Icon,
    IconBox,
    Inner,
    Tag,
    Title,
    TopRow,
    ItemType,
};
export default DownloadCardStyles;
